import { makeStyles } from "@material-ui/styles";

export const useStyles = makeStyles({
  card: {
    width: "100%",
    minHeight: "4rem",
    marginBottom: "1rem",
    backgroundColor: "#fff",
    "& .MuiTypography-h2": {
      fontSize: "1.5rem",
      fontWeight: 700,
    }
  }
});